/** @jsx isolateComponent */

import { Fragment } from 'react';

import { isolateComponent } from '@zapier/common-utils';
import { Margin, Text } from '@zapier/design-system';

type Props = {
  tasks: number;
};

export const ReducedTaskCompanyOfferModalView = ({ tasks }: Props) => (
  <Fragment>
    <Text tag="h1" textAlign="center" type="header800">
      Upgrade to Zapier for Companies
    </Text>

    <Margin margin="20px 0">
      <Text tag="p" textAlign="center" type="bodyText900">
        Get all the features of our Company plan—such as advanced access
        controls, unlimited teams, and {tasks.toLocaleString()} Tasks per
        month—for a lower price.
      </Text>
    </Margin>
  </Fragment>
);
